import OnlineOnboardingStepper from './online-onboarding-stepper';

export default OnlineOnboardingStepper;
